/* =================== SERVIÇOS HOME =================== */
$(function () {
  $(".carrosel-fotos-solucoes").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
  });
});
